// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1AnZZ","image":"App_image__lLLJS"};